import { defineNuxtPlugin } from 'nuxt/app'

// Define types for Vue instance augmentation
declare module 'nuxt/app' {
  interface NuxtApp {
    $loadScriptWithPromise: (
      src: string,
      id: string,
      attributes?: Record<string, string>,
    ) => Promise<void>
    $unloadScript: (id: string) => void
  }
}

declare module '@vue/runtime-core' {
  interface ComponentCustomProperties {
    $loadScriptWithPromise: (
      src: string,
      id: string,
      attributes?: Record<string, string>,
    ) => Promise<void>
    $unloadScript: (id: string) => void
  }
}

function unloadScript(id: string) {
  const el = document.querySelector(`#${id}`)
  if (!el) {
    return
  }
  document.head.removeChild(el)
}

function loadScriptWithPromise(
  src: string,
  id: string,
  attributes?: Record<string, string>,
): Promise<void> {
  if (document.getElementById(id)) {
    return Promise.resolve()
  }
  return new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.id = id
    script.src = src
    script.async = true
    script.defer = true

    // Apply any additional attributes
    if (attributes) {
      Object.entries(attributes).forEach(([key, value]) => {
        script.setAttribute(key, value)
      })
    }

    script.onload = () => resolve()
    script.onerror = (e) => reject(e)
    document.head.appendChild(script)
  })
}

export default defineNuxtPlugin(() => {
  return {
    provide: {
      loadScriptWithPromise,
      unloadScript,
    },
  }
})
